export enum TvTypes {

    SHOW_CHANNELS_LOADING = "SHOW_CHANNELS_LOADING",
    HIDE_CHANNELS_LOADING = "HIDE_CHANNELS_LOADING",

    REQUEST_CHANNEL_LIST = "REQUEST_CHANNEL_LIST",
    SET_CHANNEL_LIST = "SET_CHANNEL_LIST",

    SHOW_TV_CONDUCTOR_LOADING = "SHOW_TV_CONDUCTOR_LOADING",
    HIDE_TV_CONDUCTOR_LOADING = "HIDE_TV_CONDUCTOR_LOADING",

    REQUEST_TV_CONDUCTOR_LIST = "REQUEST_TV_CONDUCTOR_LIST",
    SET_TV_CONDUCTOR_LIST = "SET_TV_CONDUCTOR_LIST",
    SET_TV_CONDUCTOR_SEARCH_TEXT = "SET_TV_CONDUCTOR_SEARCH_TEXT",
    SET_TV_CONDUCTOR_CURRENR_CHANNEL = "SET_TV_CONDUCTOR_CURRENR_CHANNEL",
    SET_TV_CONDUCTOR_CURRENR_DATE = "SET_TV_CONDUCTOR_CURRENR_DATE",

    TOGGLE_TV_CONDUCTOR = "TOGGLE_TV_CONDUCTOR",
    HIDE_TV_CONDUCTOR = "HIDE_TV_CONDUCTOR",
    SHOW_TV_CONDUCTOR = "SHOW_TV_CONDUCTOR",

    GET_STREAM_URL = "GET_STREAM_URL",
    SET_STREAM_URL = "SET_STREAM_URL",
    STOP_TV_PLAYBACK_REPORTING = "STOP_TV_PLAYBACK_REPORTING",
    START_TV_PLAYBACK_REPORTING = "START_TV_PLAYBACK_REPORTING",
    DO_TV_REPORT_PLAYBACK = "DO_TV_REPORT_PLAYBACK",
    DO_TV_REPORT_STATISTIC = "DO_TV_REPORT_STATISTIC",

    SET_TV_CURRENT_EPISODE = "SET_TV_CURRENT_EPISODE",

    SET_TV_STATUS = "SET_TV_STATUS",
    SET_TV_MESSAGE = "SET_TV_MESSAGE",
    CLEAR_TV_MESSAGE = "CLEAR_TV_MESSAGE",

    SET_TV_OTHER_SESSIONS = "SET_TV_OTHER_SESSIONS",
}